<div class="panel">
  <h3 class="panel-title">Assistant</h3>
  <p class="panel-caption">Ask me to draft or tweak the campaign. Changes reflect on the form.</p>

  <div class="chat-box">
    <div class="chat-history" #chatBox>
      <div *ngFor="let msg of state.messages()" class="message-row" [class.user]="msg.role === 'user'">
        <div class="avatar" [class.user]="msg.role === 'user'">
          <img *ngIf="msg.role === 'user' && state.userPhoto()" class="avatar-photo" [src]="state.userPhoto()"
            alt="You" />
          <span *ngIf="msg.role === 'user' && !state.userPhoto()">{{ state.userInitials() }}</span>
          <span *ngIf="msg.role === 'assistant'" class="avatar-bot">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <rect x="4" y="8" width="16" height="12" rx="2" />
              <path d="M12 8V4" />
              <circle cx="12" cy="3" r="1" fill="currentColor" stroke="none" />
              <circle cx="9" cy="14" r="1.25" fill="currentColor" stroke="none" />
              <circle cx="15" cy="14" r="1.25" fill="currentColor" stroke="none" />
              <path d="M2 12v3M22 12v3" />
            </svg>
          </span>
        </div>
        <div class="bubble" [class.user]="msg.role === 'user'">{{ msg.content }}</div>
      </div>
      <div *ngIf="sending" class="message-row typing-row">
        <div class="avatar">
          <span class="avatar-bot">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <rect x="4" y="8" width="16" height="12" rx="2" />
              <path d="M12 8V4" />
              <circle cx="12" cy="3" r="1" fill="currentColor" stroke="none" />
              <circle cx="9" cy="14" r="1.25" fill="currentColor" stroke="none" />
              <circle cx="15" cy="14" r="1.25" fill="currentColor" stroke="none" />
              <path d="M2 12v3M22 12v3" />
            </svg>
          </span>
        </div>
        <div class="bubble typing-bubble" role="status" aria-label="Assistant is typing">
          <span class="typing-dot" aria-hidden="true"></span>
          <span class="typing-dot" aria-hidden="true"></span>
          <span class="typing-dot" aria-hidden="true"></span>
        </div>
      </div>
      <div *ngIf="state.messages().length === 0" class="empty-hint">
        No messages yet — try asking for a draft!
      </div>
    </div>
  </div>

  <div class="chat-input-row">
    <input class="chat-input" type="text" [(ngModel)]="userMessage" (keydown)="onKeydown($event)"
      placeholder="e.g. 'Make it high priority and add the Houston team'" [disabled]="sending" />
    <button class="send-btn" (click)="send()" [disabled]="sending || !userMessage.trim()">
      ➤
    </button>
    <p class="caution-note" role="note">AI Generated Content, please review before the sendout</p>
  </div>
</div>